import { Locale, Translation } from 'locale'
import React from 'react'
import { useSelector } from 'react-redux'
import { tradingEntityMetasGetterSelector } from 'selectors/tradingEntitySelectors'
import { aliasesDetailsGetterSelector } from 'selectors/tradingEntitySelectors/tradingEntityAliasesSelectors'
import { AgGridWrapper } from 'view/components/datagrid'
import {
  tradingEntityAliasesPanelColumnDefs,
  TradingEntityAliasesPanelGridColumnId,
  tradingEntityAliasesPanelGridOptions
} from './TradingEntityAliasesPanelGridModel'
import { GroupboxStyled, Header } from './TradingEntityAliasesPanelStyles'

const nonEditableColDefs = tradingEntityAliasesPanelColumnDefs.filter(c => c.colId !== TradingEntityAliasesPanelGridColumnId.ACTIONS)

export const ViewTradingEntityAliasesPanel = ({ tradingEntityId }: { tradingEntityId: string }) => {
  const getTradingEntityMetas = useSelector(tradingEntityMetasGetterSelector)
  const tradingEntityMetas = getTradingEntityMetas(tradingEntityId)
  const getAliasesDetails = useSelector(aliasesDetailsGetterSelector)

  const aliasesDetails = getAliasesDetails(tradingEntityMetas)

  return (
    <GroupboxStyled>
      <Header>
        <label>{Locale.translate(Translation.TC_TRADING_ENTITY_ALIAS)}</label>
      </Header>

      <AgGridWrapper
        className="datagrid-borderless"
        columnDefs={nonEditableColDefs}
        gridOptions={tradingEntityAliasesPanelGridOptions}
        placeholder={NoAliasesMessagePlaceholder}
        rowData={aliasesDetails}
      />
    </GroupboxStyled>
  )
}

function NoAliasesMessagePlaceholder() {
  return <div>{Locale.translate(Translation.TC_NO_ALIASES)}</div>
}
